const e=e=>e.length?e[0].toUpperCase()+e.slice(1):"";export{e as default};
